import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/onboarding/createWorkspace';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';

function* operation(action) {
  const { body, meta } = action.payload;
  try {
    const res = yield call(
      axios.post,
      `${config.API_URL}/workspace`,
      body,
      { headers: getLocalUser() },
    );
    const data = res.data?.data || res.data;
    const newId = data.uid || data.workspace_id;
    if (!newId) {
      yield put(fetchFailure('Workspace was created but no id came back.'));
      return;
    }
    yield put(fetchSuccess({ id: newId, ...meta }));
  } catch (e) {
    yield put(ErrorAction(e));
    yield put(fetchFailure(
      e.response?.data?.data?.message || e.response?.data?.status || e.message || 'Could not create the workspace.',
    ));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
